<template>
  <login-form
    :title="title"
    go-action="Submit"
    @submit="login"
    :loading="loading"
    logo="/logo.png"
    :errors="errors"
  >
    <password-input
      v-show="!totpRequired"
      v-model="password"
      label="PIN"
      autofocus />

    <div v-show="totpRequired">
      <v-text-field
        ref="totpField"
        prepend-icon="$lock"
        label="Authenticator Code (TOTP)"
        name="totp"
        type="tel"
        autocomplete="off"
        v-model="tfaCode"
      />
    </div>

    <template v-slot:actions>
      <v-btn v-if="!totpRequired"
             @click="reset"
             :disabled="loading"
             color="secondary">Forgot PIN?</v-btn>
    </template>
  </login-form>
</template>

<script>
import LoginForm from '@/components/Form'
import { mapGetters } from 'vuex'
import { ROUTE_NAME as ROUTE_NAME_USER_CODE } from '@/views/UserCode'
import { STATE_CHALLENGE, STATE_USER_ID } from '@/store'
import PasswordInput from '@/components/PasswordInput'
import mixinHandleError from '@/mixins/handle-error'

export const ROUTE_NAME = 'UserPIN'

export default {
  name: ROUTE_NAME,
  mixins: [mixinHandleError],
  components: {
    LoginForm,
    PasswordInput
  },
  computed: {
    ...mapGetters({
      challenge: STATE_CHALLENGE,
      userID: STATE_USER_ID
    }),
    title () {
      return this.totpRequired ? 'Two Factor Authentication' : 'PIN'
    },
    tfaRequired () {
      return this.totpRequired
    }
  },
  data: () => ({
    password: '',
    tfaCode: '',
    tfType: '',
    loading: false,
    submitting: false,
    resetting: false,
    totpRequired: false
  }),
  methods: {
    async reset () {
      this.resetting = true
      this.loading = true
      this.clearErrors()
      try {
        await this.axios.post('/api/v1/login/reset', {
          challenge: this.challenge,
          uid: '' + this.userID
        })
        this.$router.push({
          name: ROUTE_NAME_USER_CODE
        })
      } catch (err) {
        this.storError(err)
      }
      this.loading = false
      this.resetting = false
    },
    async login () {
      this.loading = true
      this.submitting = true
      this.clearErrors()
      try {
        const resp = await this.axios.post('/api/v1/login/pin', {
          challenge: this.challenge,
          uid: '' + this.userID,
          password: this.password,
          tfa: this.tfaCode,
          tfa_type: this.tfaType
        })
        if (resp.headers.location) {
          window.location = resp.headers.location
          return
        }
        throw new Error(
          `no headers on response: ${JSON.stringify(resp, null, 2)}`
        )
      } catch (err) {
        if (err.code !== 417) {
          this.storeError(err)
        } else if (!err.data || !err.data.tfa_type) {
          this.storeError(err)
        } else {
          this.tfaType = err.data.tfa_type
          switch (this.tfaType) {
            case 'TOTP':
              this.totpRequired = true
              this.$nextTick(this.$refs.totpField.focus)
              break
            default:
              this.storeError(err)
              break
          }
        }
      }
      this.submitting = false
      this.loading = false
    }
  }
}
</script>
